import React, { Component } from 'react';
import AlertBannerBlock from "../../../../generic_components/components/text_display/AlertBannerBlock";

//get static routes
import {
    cari_api_load_outage_banner_url
} from "../../../../router/static_routes"

import {
    fetchCariOutageMessages
} from "../../../../functions/generic_functions";

/*
    props:
        siteTitle : title of the header
*/
class CariMainPgHeaderView extends Component {
    state = {
        outageMessages: [],
    }

    constructor(props) {
        super(props);
        this.loadOutageBannerFromApi = this.loadOutageBannerFromApi.bind(this);
    }
    

    loadOutageBannerFromApi() {
        fetchCariOutageMessages(cari_api_load_outage_banner_url).then((fetchedOutageMessages) => {
            this.setState({
                outageMessages: fetchedOutageMessages,
            });
        }).catch((error) => {
            console.log(error);
        });
    }

    componentDidMount() {
        this.loadOutageBannerFromApi();
    }

    render() {
        return (
            <div>
                <header>
                    <section className='heading'>
                        <div className='brand-title'>
                            <div className='site-title'>
                                <a href="http://beedie.sfu.ca">
                                    <div className='branding'>
                                        <h1 className="">
                                            Beedie School of Business
                                        </h1>
                                    </div>
                                </a>
                            </div>
                            <div className='site-title'>
                                <h2 className="site_header_title_font_color">
                                    {this.props.siteTitle}
                                </h2>
                            </div> 
                        </div>
                    </section>
                </header>
                {this.state.outageMessages &&  this.state.outageMessages.length > 0 ? (
                    <AlertBannerBlock messages={this.state.outageMessages} alertType="danger" />  
                ) : null}
            </div>
        );
    }
}
export default CariMainPgHeaderView;